import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import WhatsAppWidget from "../components/WhatsAppWidget";

const API = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function UniversityDirectoryPage() {
  const [universities, setUniversities] = useState([]);
  const [country, setCountry] = useState("");
  useEffect(() => {
    fetch(
      `${API}/institutions${country ? `?country=${encodeURIComponent(country)}` : ""}`,
    )
      .then((r) => r.json())
      .then((j) => setUniversities(j.data || []));
  }, [country]);
  const countries = [...new Set(universities.map((u) => u.country))];
  return (
    <div>
      <main className="min-h-screen bg-[#f7f9fb] pt-24 pb-16">
        <section className="max-w-6xl mx-auto px-5">
          <p className="uppercase text-xs font-bold tracking-widest text-[#365da3]">
            Find your institution
          </p>
          <h1 className="text-4xl font-bold text-[#00255a] mt-2">
            University directory
          </h1>
          <p className="text-slate-600 mt-3 max-w-2xl">
            Compare partner universities, transparent tuition pricing and the
            details that matter before you apply.
          </p>
          <div className="mt-7 flex gap-2 flex-wrap">
            <button
              onClick={() => setCountry("")}
              className={`px-4 py-2 rounded-full ${!country ? "bg-[#00255a] text-white" : "bg-white border"}`}
            >
              All countries
            </button>
            {countries.map((c) => (
              <button
                key={c}
                onClick={() => setCountry(c)}
                className={`px-4 py-2 rounded-full ${country === c ? "bg-[#00255a] text-white" : "bg-white border"}`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            {universities.map((u) => (
              <Link
                to={`/universities/${u.id}`}
                key={u.id}
                className="bg-white rounded-2xl overflow-hidden border border-slate-200 hover:-translate-y-1 transition shadow-sm"
              >
                <div className="h-36 bg-gradient-to-br from-[#00255a] to-[#365da3] flex items-center justify-center">
                  {u.heroImageUrl ? (
                    <img
                      src={u.heroImageUrl}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  ) : u.logoUrl ? (
                    <img
                      src={u.logoUrl}
                      alt=""
                      className="max-w-24 max-h-24 object-contain bg-white rounded-xl p-2"
                    />
                  ) : (
                    <span className="material-symbols-outlined text-white text-5xl">
                      account_balance
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <p className="text-sm text-[#365da3]">{u.country}</p>
                  <h2 className="font-bold text-xl text-[#00255a] mt-1">
                    {u.name}
                  </h2>
                  <p className="text-sm text-slate-600 mt-2 line-clamp-2">
                    {u.description ||
                      "View institution details, tuition and student advantages."}
                  </p>
                  <p className="mt-4 font-bold text-[#00255a]">
                    {u.discountFee
                      ? `${u.feeCurrency} ${u.discountFee.toLocaleString()} / year`
                      : "View fees"} discount
                  </p>
                </div>
              </Link>
            ))}
          </div>
          {universities.length === 0 && (
            <p className="text-center text-slate-500 py-16">
              No approved universities are currently available.
            </p>
          )}
        </section>
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}
